import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import GridItem from './GridItem';

const SortableGridItem = ({
  item, onClick, onContextMenu, activeItem, themeColors, onInfoClick,
  onMoveTo, disabled, isSelected, hasSelection = false, onToggleSelect, onRssClick, density,
}) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: item.id,
    disabled,
  });

  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
    zIndex: isDragging ? 50 : 'auto',
    opacity: isDragging ? 0.25 : 1,
    pointerEvents: isDragging ? 'none' : 'auto',
    touchAction: isDragging ? 'none' : 'manipulation',
    WebkitUserSelect: 'none',
    userSelect: 'none',
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <GridItem
        item={item}
        onClick={onClick}
        onContextMenu={onContextMenu}
        isDragging={isDragging}
        themeColors={themeColors}
        onInfoClick={onInfoClick}
        onMoveTo={onMoveTo}
        isSelected={isSelected}
        hasSelection={hasSelection}
        onToggleSelect={onToggleSelect}
        onRssClick={onRssClick}
        density={density}
      />
    </div>
  );
};

export default SortableGridItem;